import { BackToOptionsButton } from '../../components/BackToOptionsButton';
import { SignUpCard } from '../SignUpCard';
import { UnauthedPageWithNavbar } from '../../../layout/UnauthedPageWithNavbar';
import CorporateVolunteer from './corporate-volunteer.svg';
import IndividualVolunteer from './individual-volunteer.svg';

type VolunteerSelectionPageProps = {
  setCorporateVolunteerSelected: (selected: boolean) => void;
  setIndividualVolunteerSelected: (selected: boolean) => void;
  setVolunteerSelected: (selected: boolean) => void;
};

export const VolunteerSelectionPage = (props: VolunteerSelectionPageProps) => {
  const { setVolunteerSelected, setCorporateVolunteerSelected, setIndividualVolunteerSelected } =
    props;

  return (
    <UnauthedPageWithNavbar>
      <div className='md:w-full flex flex-col items-center mt-[20px] md:mt-[100px] gap-10 l px-4'>
        <h3 className='text-center text-display-md font-medium text-gray-700'>
          What kind of volunteer are you?
        </h3>
        <div className='flex flex-col md:flex-row gap-[48px]'>
          <SignUpCard
            img={CorporateVolunteer}
            header='Corporate Volunteer'
            description="I've been sponsored by my employer for a program"
            onClick={() => {
              setCorporateVolunteerSelected(true);
              setIndividualVolunteerSelected(false);
            }}
          />

          <SignUpCard
            img={IndividualVolunteer}
            header='Individual Volunteer'
            description="I'm a professional volunteering on my own"
            onClick={() => {
              setCorporateVolunteerSelected(false);
              setIndividualVolunteerSelected(true);
            }}
          />
        </div>
        <div>
          Not sure which one you are?{' '}
          <a
            className='text-brand-500 underline'
            href='https://zsupport.movingworlds.org/portal/en/kb/articles/why-can-t-i-log-in-to-my-account'
          >
            Learn more
          </a>
        </div>
        <BackToOptionsButton
          onClick={() => {
            setCorporateVolunteerSelected(false);
            setVolunteerSelected(false);
            setIndividualVolunteerSelected(false);
          }}
        />
      </div>
    </UnauthedPageWithNavbar>
  );
};
